import { render, staticRenderFns } from "./ApprovalFormApplications.vue?vue&type=template&id=a45b4382"
import script from "./ApprovalFormApplications.vue?vue&type=script&lang=js"
export * from "./ApprovalFormApplications.vue?vue&type=script&lang=js"
import style0 from "./ApprovalFormApplications.vue?vue&type=style&index=0&id=a45b4382&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports